import type { Optional } from '@festina-life/core'
import { Icon, type IconName } from '@festina-life/ui/structure'

type Props = {
  iconName: Optional<IconName>
  label: string
  iconClassName?: string
}

export const ConfigurationBreadcrumbPart = ({
  iconName,
  label,
  iconClassName,
}: Props) => (
  <span className="flex items-center gap-1">
    {iconName && <Icon name={iconName} className={iconClassName} />}
    {label}
  </span>
)
